import { EventManager } from '../services/event-manager.service';
var MapService = /** @class */ (function () {
    function MapService() {
        this.eventManager = EventManager.Instance;
        this.APIKey = 'AIzaSyAwICZ8NQiSHrEeYuhK1E4phHg531s7IcQ';
        this.mapUrl = "https://maps.googleapis.com/maps/api/js?key=" + this.APIKey;
        this.eventManager.register('componentsLoaded', null, this.init);
    }
    MapService.prototype.init = function () {
        var _this = this;
        if (!document.querySelectorAll("[src=\"" + this.mapUrl + "\"]").length) {
            if (this.mapUrl !== undefined) {
                document.body.appendChild(Object.assign(document.createElement('script'), {
                    type: 'text/javascript',
                    src: this.mapUrl,
                    onload: function () { return _this.broadcastEvent(); }
                }));
            }
        }
    };
    MapService.prototype.broadcastEvent = function () {
        this.eventManager.emit('googleMapsReady');
    };
    return MapService;
}());
export { MapService };



//////////////////
// WEBPACK FOOTER
// ./services/map.service.ts
// module id = 27
// module chunks = 0